import {createMuiTheme} from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';

export const styles = theme => ({
    root: {
        width: '100%',
        maxWidth: 90,
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing.unit * 4,
    },
    avatar: {
        width: 30,
        height: 30
    },
    // menufont: {
    // 	"font-size": "0.75rem",
    // },
	// menufontBold: {
    //     "font-size": "0.75rem",
	// 	"font-weight": "bold"
    // },
    image: {
        flex: 1,
        alignSelf: 'stretch',
        width: "50%",
        height: "50%"
    },

    //text
    menuTopLevel: {
        width: "12vw",
        fontWeight: "bold",
        fontSize: "14px"
    },
    menuSubLevel: {
        overflowX:'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        fontSize: '14px'
    }

})
const paddingDefault = 15
const paddingSubLevel = 12
export const menuPadding = depth => {
    return {
        paddingLeft:(paddingDefault + paddingSubLevel * depth) + "px",
        paddingTop: '5px',
        paddingBottom: '5px',
    };
};
// use by all pages
export const theme = createMuiTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1100,
            xl: 1500
        }
    },
    typography: {
        useNextVariants: true,
        // subtitle1: {
        //     fontSize: 50,
        // },
        // colorTextSecondary: {
        // },
        // headline: {
        // },
        subtitle1: {
            color: grey[900]
        },
        //Table header
        subtitle2: {
            whiteSpace: 'nowrap',
            color: grey[900]
        },
        h6: {
            fontSize: "1.1rem",
            fontWeight: "400"
        },
        title: {
            fontSize: "1.1rem",
            fontWeight: "400"
        },
        h5: {
            fontSize: '1rem',
            color: grey[900]
        },
        body1: {
            color: grey[800]
        },
        //Table content
        body2: {
            fontSize: '0.7rem',
            color: grey[800]
        }
    }
});


// WEBPACK FOOTER //
// ./src/components/CSS/MenuStyles.js